import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class SelectedVehicleActions {
  /**
  * @var Declaration of the action to set the vehicle
  **/
  static readonly SET_SELECTED_VEHICLE = 'SET_SELECTED_VEHICLE';
  /**
  * @var Declaration of the action to reset selected vehicle store
  **/
  static readonly RESET_SELECTED_VEHICLESTORE = 'RESET_SELECTED_VEHICLESTORE';
  /**
  * setSelectedVehicle sets the selected vehicle
  * @param vehicle Value of the vehicle (T or L)
  **/
  static setSelectedVehicle(vehicle: object) {
    return {
      type: SelectedVehicleActions.SET_SELECTED_VEHICLE,
      payload: { vehicle: vehicle }
    };
  }
  /**
   * resetSelectedVehicleStore resets the selected vehicle store
   **/
  static resetSelectedVehicleStore() {
    return {
      type: SelectedVehicleActions.RESET_SELECTED_VEHICLESTORE
    };
  }
}
